<template>
    <Card :class="wrapperClasses">
        <template v-slot:header>
            <SpacingClassWrapper 
                :padding-left="$mq | mq({ sm: 6, md: 6, pccFullSize: 2 })"
                :padding-top="$mq | mq({ sm: 6, md: 6, pccFullSize: 3 })"
                :padding-right="$mq | mq({ sm: 6, md: 6, pccFullSize: 2 })"
            >
                <header :class="headerClasses">
                    <Typography
                        :variant="typographyVariants.heading3"
                        :weight="typographyWeights.bold"
                        :color="$mq | mq({
                            sm: typographyColors.dark,
                            md: typographyColors.dark
                        })"
                    >
                        {{ headerTitle }}
                    </Typography>
                </header>
            </SpacingClassWrapper>
        </template>
        <SpacingClassWrapper 
            :padding-top="$mq | mq({ sm: 6, pccFullSize: 4 })"
            :padding-left="$mq | mq({ sm: 6, pccFullSize: 3 })"
            :padding-right="$mq | mq({ sm: 6, pccFullSize: 3 })"
            :padding-bottom="$mq | mq({ sm: 6, pccFullSize: 3 })"
        >
            <div>
                <slot />
            </div>
        </SpacingClassWrapper>
    </Card>
</template>

<script>
// Components
import Card from '../../components/Card'
import Typography from '../../components/Typography';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';

// Types
import { 
    typographyVariants,
    typographyWeights,
    typographyColors
} from '../../types/Typography.types';

// Mixins
import styles from '../../mixins/styles.js';

export default {
    name: 'CardContainer',
    components: {
        Card,
        Typography,
        SpacingClassWrapper,
    },
    mixins: [styles],
    props: {
        headerTitle: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            typographyVariants,
            typographyWeights,
            typographyColors
        }
    },
    computed: {
        isMobile: function() { return this.$mq === 'sm' || this.$mq === 'md'; },
        wrapperClasses: function () {
            return [ 
                this.cssClasses.pcc__resultCardContianer,
                this.cssClasses[`pcc__resultCardContianer_${this.isMobile ? 'mobile' : 'desktop'}`],
            ];
        },
        headerClasses: function () {
            return [
                this.cssClasses.pcc__resultCardContianer_header,
                this.cssClasses[`pcc__resultCardContianer_header${this.isMobile ? 'Mobile' : 'Desktop'}`],
            ];
        }
    },
}
</script>
